import { useState } from "react"
import Campaign from "./Campaign/Campaign"
import AdGroup from "./AdGroup/AdGroup"
import KeywordPerformance from "./KeywordPerformance/KeywordPerformance"
import ProductPerformance from "./ProductPerformance/ProductPerformance"
import PlacementPerformance from "./PlacementPerformance/PlacementPerformance"

const Performance = () => {

  const tabs = ["Campaign", "Ad Group", "Keyword", "Product", "Placement"]
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <section>
      <div className="fw-semibold fs-4 my-3">Performance</div>

      <div className="d-flex mt-3 gap-3 border-bottom border-subtle-secondary text-nowrap flex-nowrap overflow-x-auto">
        {tabs.map((tab) => (
          <div
            className="fw-medium"
            style={{
              color: tab === activeTab ? "#EC7426" : "black",
              cursor: "pointer",
              transition: "color .3s ease",
              fontSize: "1.25rem",
              padding: ".5rem 0rem",
            }}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>



      {activeTab === "Campaign" && <Campaign />}
      {activeTab === "Ad Group" && <AdGroup />}
      {activeTab === "Keyword" && <KeywordPerformance />}
      {activeTab === "Product" && <ProductPerformance />}
      {activeTab === "Placement" && <PlacementPerformance />}

    </section>
  )
}

export default Performance
